export const CHANGED_LEASING = 'CHANGED_LEASING';